import { CommonModule, NgClass, isPlatformBrowser } from '@angular/common';
import { Component, signal, computed, OnInit, Inject, PLATFORM_ID, effect, HostListener, ElementRef } from '@angular/core';
import { UsersService } from '../../_services/users.service';
import { Router, RouterModule } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ToastService } from '../../_services/toast.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { AuthService } from '../../_services/auth.service';



// 1. Define the Data Interface
export interface User {
  _id: string;
  name: string;
  email: string;
  phone: string;
  role: any;
  status: 'Active' | 'Busy' | 'Offline' | 'Inactive';
  state:'Pending'| 'Approved' |'Rejected',
  isUserType:'Premium' | 'Basic'
  assignedAdvisor:any
  requestsCount?: number;
  createdAt:any;
  updatedAt:any;
  subsctions:any;
  country:any

  
  // img: string;
  // active: string;
  // location?: string;
  // stats?: { sales: number; revenue: string; rating: number };
}

@Component({
  selector: 'app-users',
  imports: [
    NgClass,
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss',
  animations: [
    trigger('modalAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.95) translateY(10px)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'scale(1) translateY(0)' }))
      ]),
      transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0, transform: 'scale(0.95) translateY(10px)' }))
      ])
    ]),
    trigger('fadeAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('150ms ease-in', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class UsersComponent implements OnInit {
  user = signal<any>(null);
  users = signal<User[]>([]);
  isSidebarCollapsed = signal(false);
  selectedUser = signal<User | null>(null);
  isDrawerOpen = computed(() => this.selectedUser() !== null);
  userForm: any = FormGroup;
  showUserModal = false;
  searchTerm = signal('');
  passwordVisible = false;
  countries: any[] = [];
  selectedCountry: any = null;
  dropdownOpen = false;
  searchQuery = '';
  USER_ROlE: any = {
    id: 'user',
    label: 'User',
    icon: 'user',
    permissions: {
      canManageUsers: false,
      canDeleteProperties: false,
      canViewFinance: false,
      canEditSettings: false,
      canAddProperties: false,
      canShowAllProperties: false,
      canOnboardAdvisor: false,
      canDeleteAdvisor: false,
      CanShareProperties: false,
    },
  };
  approvalFilter = signal<'ALL' | 'Approved' | 'Pending' | 'Rejected' | 'Premium' >('ALL');
  userTypeFilter = signal<'ALL' | 'Premium' | 'Basic'>('ALL');

  advisorStatusFilter = signal<'ALL' | 'ASSIGNED' | 'NOT_ASSIGNED'>('ALL');
  advisorFilter = signal<string>('ALL'); 
  constructor(
    public _US: UsersService,
    private router: Router,
    private fb: FormBuilder,
    private _NS: ToastService,
    public authService: AuthService,
    private _AS: AuthService,
    private el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      const stored = localStorage.getItem('Admin_User');

      if (stored) {
        const parsed = JSON.parse(stored);
        this.user.set(parsed.data ?? parsed);
      }
    }
    effect(() => {
      const _ = [
        this.advisorFilter(),
        this.approvalFilter(),
        this.userTypeFilter(),
        this.advisorStatusFilter()
      ];

      this.currentPage.set(1);
    });
  }
  
  hasRole(roleName: string): boolean {
    return this.user()?.role?.id === roleName;
  }

  isSuperAdmin(): boolean {
    return this.hasRole('super_admin');
  }


  isSalesAdvisor(): boolean {
    const role = this.user()?.role;

    if (!role) return false;

    return role.id === 'sales_advisor';
  }

  isAdmin(): boolean {
    const role = this.user()?.role;

    if (!role) return false;

    return role.id === 'admin';
  }

  isAdminOrSuperAdmin(): boolean {
    const roleId = this.user()?.role?.id;
    return ['admin', 'super_admin'].includes(roleId);
  }

  ngOnInit(): void {
    this.getAllUsers();
    this.formControles();
    this.getCode();

    const currentUser = this.user();
    const roleId = currentUser?.role?.id;

    if (roleId === 'sales_advisor') {
      this.advisorFilter.set(currentUser?.name);
    }
  }

  getAllUsers() {
    this._US.getAllUser().subscribe({
      next: (res: any) => {
        const userData = res?.data || res; 

        // const usersWithCount = userData.map((user: any) => ({
        //   ...user,
        //   requestCount: 0
        // }));

        this.users.set(userData);

        this.currentPage.set(1);

      //   usersWithCount.forEach((user: any) => {
      //     this._US.getUserPropertyReq(user._id).subscribe({
      //       next: (reqRes: any) => {
      //         user.requestCount = reqRes?.data?.length || 0;
      //         this.users.set([...this.users()]);
      //       },
      //       error: () => {
      //         user.requestCount = 0;
      //       }
      //     });
      //   });
      }
    });
  }

  isAdvisorAssigned(user: any): boolean {
    return !!user?.assignedAdvisor?.advisorId;
  }

  formControles() {
    this.userForm = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [
        Validators.required,
        Validators.email
      ]],

      phone: ['', [
        Validators.required,
        Validators.pattern('^[0-9]{7,15}$')
      ]],

      password: ['', [
        Validators.required,
        Validators.minLength(5)
      ]],

      country: ['', Validators.required],
      statusReason: ['', Validators.required],
      role: [this.USER_ROlE, [Validators.required]],

      isApproved: [true, [Validators.required]],

      state: ['Approved', [Validators.required]],
    });
  }

  // selectUser(user: User) {
  //   this.selectedUser.set(user);
  // }
  toggleSidebar() {
    this.isSidebarCollapsed.update((v) => !v);
  }

  closeDrawer() {
    this.selectedUser.set(null);
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'Active':
        return 'bg-green-100 text-green-700 ring-green-600/20';
      case 'Busy':
        return 'bg-red-100 text-red-700 ring-red-600/20';
      case 'Offline':
        return 'bg-gray-100 text-gray-600 ring-gray-500/10';
      default:
        return 'bg-yellow-50 text-yellow-700 ring-yellow-600/20';
    }
  }

  getStatusDot(status: string): string {
    return status === 'Active'
      ? 'bg-green-500'
      : status === 'Busy'
      ? 'bg-red-500'
      : 'bg-gray-400';
  }

  // Prevent click propagation for action buttons
  editUser(e: Event, user: User) {
    e.stopPropagation();
    console.log('Edit clicked for', user.name);
  }


editForm!: FormGroup;
isSaving = false;

// call this when drawer opens
selectUser(user: any) {
  this.selectedUser.set(user);
  this.editForm = this.fb.group({
    name:  [user.name,  [Validators.required]],
    email: [user.email, [Validators.required, Validators.email]],
    state: [user.state, [Validators.required]],
    phone: [user.phone, [Validators.required]],
    country: [user.country, [Validators.required]],
  });
}
getDaysRemaining(endDate: string): number {
  const end = new Date(endDate).getTime();
  const now = new Date().getTime();
  return Math.max(0, Math.ceil((end - now) / (1000 * 60 * 60 * 24)));
}

getSubscriptionProgress(startDate: string, endDate: string): number {
  const start = new Date(startDate).getTime();
  const end   = new Date(endDate).getTime();
  const now   = new Date().getTime();
  const total = end - start;
  const elapsed = now - start;
  return Math.min(100, Math.max(0, Math.round((elapsed / total) * 100)));
}

saveUser() {
  if (this.editForm.invalid) return;
  this.isSaving = true;

  const payload = this.editForm.value;
  const userId:any  = this.selectedUser()?._id;

  this._US.editUser(userId, payload).subscribe({
    next: (res) => {
      this.isSaving = false;
      this.getAllUsers()
      const updatedUsers = this.users().map((u: any) =>
        u._id === userId ? { ...u, ...payload } : u
      );
      this.users.set(updatedUsers);

      this._NS.success('User updated successfully');
      this.closeDrawer();
    },
    error: (err) => {
      this.isSaving = false;
      this._NS.error(err?.error?.message || 'Failed to update user');
      console.error('Edit failed', err);
    }
  });
}

  
  viewDetails(user: any): void {
    this.router.navigate(['admin/users/user-info'], {
      queryParams: {
        id: user._id,
        mode: 'details',
      },
    });
  }
  onSubmit() {
    if (this.userForm.valid) {
      const payload = {
        ...this.userForm.value,
        phone: `${this.userForm.value.phone}`
      };

      this._US.createUser(payload).subscribe({
        next: (res: any) => {
          if (res.status) {
            this._NS.success(res.message);
            this.getAllUsers();
            this.showUserModal = false;
          }
        },
        error: (err: any) => {
          const msg = err?.message || 'Something went wrong';
          this._NS.error(`Error ${err?.originalError?.error?.error || err.status}: ${msg}`);
        }
      });
    }
  }

  // Search and Pagination Logic
  filteredUsers = computed(() => {
    const term = this.searchTerm().toLowerCase();
  
    return this.users().filter((user: any) => {
  
      // 🔍 SEARCH
      const matchesSearch =
        !term ||
        user.name?.toLowerCase().includes(term) ||
        user.email?.toLowerCase().includes(term) ||
        user.phone?.includes(term);
  
      // ✅ APPROVAL FILTER (state only)
      const matchesApproval =
        this.approvalFilter() === 'ALL' ||
        user.state === this.approvalFilter();
  
      // 💎 PREMIUM / USER-TYPE FILTER (type only)
      const matchesPremiumUser =
        this.userTypeFilter() === 'ALL' ||
        user.isUserType === this.userTypeFilter();
        console.log(this.userTypeFilter(),matchesPremiumUser, user.isUserType)
      // 👤 ADVISOR STATUS FILTER
      const isAssigned = !!user?.assignedAdvisor?.advisorId;
      const matchesAdvisorStatus =
        this.advisorStatusFilter() === 'ALL' ||
        (this.advisorStatusFilter() === 'ASSIGNED' && isAssigned) ||
        (this.advisorStatusFilter() === 'NOT_ASSIGNED' && !isAssigned);
  
      // 🧑‍💼 SPECIFIC ADVISOR FILTER
      const filterValue = this.advisorFilter() || 'ALL';
      const matchesAdvisor =
        filterValue === 'ALL' ||
        user?.assignedAdvisor?.advisorId === filterValue ||
        user?.assignedAdvisor?.name === filterValue;
        console.log( matchesSearch,
          matchesApproval,
          matchesPremiumUser,
          matchesAdvisorStatus,
          matchesAdvisor)
      return (
        matchesSearch &&
        matchesApproval &&
        matchesPremiumUser &&
        matchesAdvisorStatus &&
        matchesAdvisor
      );
    });
  });
  

  onSearchChange(value: string) {
    this.searchTerm.set(value);
    this.currentPage.set(1);
  }

  // Pagination
  currentPage = signal(1);
  itemsPerPage = signal(10);

  totalUsers = computed(() => this.filteredUsers().length);

  totalPages = computed(() =>
    Math.ceil(this.totalUsers() / this.itemsPerPage())
  );

  paginatedUsers = computed(() => {
    console.log('this.filteredUsers()',this.filteredUsers())
    const reversed = [...this.filteredUsers()].reverse(); // 🔥 latest first

    const start = (this.currentPage() - 1) * this.itemsPerPage();
    const end = start + this.itemsPerPage();

    return reversed.slice(start, end);
  });

  changePage(page: number) {
    if (page < 1 || page > this.totalPages()) return;

    this.currentPage.set(page);

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
  

  

  uniqueAdvisors = computed(() => {
    const users = this.users();
    const map = new Map();

    users.forEach((u: any) => {
      if (u.assignedAdvisor?.advisorId) {
        map.set(u.assignedAdvisor.advisorId, u.assignedAdvisor.name);
      }
    });

    return Array.from(map.entries()).map(([id, name]) => ({
      id,
      name
    }));
  });

  totalUsersCount = computed(() => this.users().length);

  approvedUsersCount = computed(() =>
    this.users().filter(u => u.state === 'Approved').length
  );

  pendingUsersCount = computed(() =>
    this.users().filter(u => u.state === 'Pending').length
  );

  rejectedUsersCount = computed(() =>
    this.users().filter(u => u.state === 'Rejected').length
  );
  premiumUsersCount = computed(() =>
    this.users().filter(u => u.isUserType === 'Premium').length
  );

  // isNewUser(createdAt: string): boolean {
  //   const created = new Date(createdAt).getTime();
  //   const now = new Date().getTime();
  //   const diffInHours = (now - created) / (1000 * 60 * 60);
  //   return diffInHours <= 3;
  // }
  isNewUser(createdAt: string): boolean {
    const created = new Date(createdAt).getTime();
    const now = new Date().getTime();
    const diffInDays = (now - created) / (1000 * 60 * 60 * 24);
    return diffInDays <= 3;
  }
  getCode() {
  this._AS.getCountryCode().subscribe((res: any) => {
    this.countries = res;

    this.selectedCountry =
      this.countries.find((c: any) => c.code === 'IN');

    this.userForm.patchValue({
      country: this.selectedCountry
    });

    this.editForm.patchValue({
      country: this.selectedCountry
    });

  });
}

get filteredCountries() {
  const q = this.searchQuery.toLowerCase();

  return this.countries.filter(
    (c: any) =>
      c.name.toLowerCase().includes(q) ||
      c.dial.includes(q)
  );
}

toggleDropdown(event: Event) {
  event.stopPropagation();
  this.dropdownOpen = !this.dropdownOpen;
}

selectCountry(country: any) {
  this.selectedCountry = country;
  this.dropdownOpen = false;
  this.searchQuery = '';

  this.userForm.patchValue({
    country: country
  });
  this.editForm.patchValue({
    country: country
  });
}

@HostListener('document:click', ['$event'])
  onOutsideClick(e: Event) {
    if (!this.el.nativeElement.contains(e.target)) {
      this.dropdownOpen = false;
    }
  }


  exportUsersCSV() {
    const users = this.filteredUsers();

    if (!users.length) {
      this._NS.error('No data to export');
      return;
    }

    const csvData = users.map((user: any, index: number) => ({
      Sr_No: index + 1,
      Name: user.name || '',
      Email: user.email || '',
      Phone: `${user?.country?.dial || ''} ${user.phone || ''}`,
      State: user.state || '',
      User_Type: user.isUserType || '',
      Advisor: user?.assignedAdvisor?.name || 'No Advisor',
      Created_At: user.createdAt || '',
      Updated_At: user.updatedAt || '',
      Requests: user.requestCount || 0
    }));

    const headers = Object.keys(csvData[0]);

    const csvRows = [
      headers.join(','),
      ...csvData.map(row =>
        headers.map(field =>
          `"${String(row[field as keyof typeof row]).replace(/"/g, '""')}"`
        ).join(',')
      )
    ];

    const blob = new Blob([csvRows.join('\n')], {
      type: 'text/csv;charset=utf-8;'
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = `users_${new Date().getTime()}.csv`;

    link.click();

    window.URL.revokeObjectURL(url);

    this._NS.success('CSV Exported Successfully');
  }
  isRoteHasPermissions(per: any): boolean {
    const isPermisson = this.authService.hasPermission(per);
    if (isPermisson) {
      return isPermisson;
    } else {
      return isPermisson
    }
  }

  visiblePages(): (number | string)[] {

    const total = this.totalPages();
    const current = this.currentPage();

    const pages: (number | string)[] = [];

    // Always show first page
    pages.push(1);

    // Left dots
    if (current > 3) {
      pages.push('...');
    }

    // Middle pages
    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    // Right dots
    if (current < total - 2) {
      pages.push('...');
    }

    // Last page
    if (total > 1) {
      pages.push(total);
    }

    return [...new Set(pages)];
  }
  onApprovalOrTypeChange(value: string) {
    debugger
    if (value === 'Premium') {
      this.userTypeFilter.set('Premium')
      this.approvalFilter.set('ALL'); // reset the other filter so they don't conflict
    } else {
      this.approvalFilter.set(value as any);
      this.userTypeFilter.set('ALL')
    }
  }
}
